<app-search-bank-records-form></app-search-bank-records-form>

<app-bank-record-table
  *ngIf="this.bankRecordService.showInfoTableBankRecord"
></app-bank-record-table>
